<template>
    <div class="container">
        <div class="main__top">
            <h1 class="main__title wow fadeInDown" data-wow-duration="1.5s">categories</h1>
        </div>
        <div class="profile">

            <ul class="nav nav-tabs justify-content-start" role="tablist">
                <li class="nav-item">
                    <a
                        class="nav-link"
                        :class="{ active: sortStatus === 'active' }"
                        role="tab"
                        @click="sortStatus = 'active'"
                    >Active Category</a>
                </li>
                <li class="nav-item">
                    <a
                        class="nav-link"
                        :class="{ active: sortStatus === 'inactive' }"
                        role="tab"
                        @click="sortStatus = 'inactive'"
                    >Inactive Category</a>
                </li>
                <li style="margin-left: auto;">
                    <a href="/admin/category/create" class="btn btn_primary-outline">+ Add Category</a>
                </li>
            </ul>

            <div class="tab-content p-0" id="myTabContent">
                <div
                    class="tab-pane fade show active"
                    id="first"
                    v-if="sortedCategories.length > 0"
                >
                    <form action="">
                        <div class="categories">
                            <div class="categories__table">
                                <ul class="categories__list">
                                    <draggable v-model="sortedCategories" @end="onDragEnd">
                                        <li
                                            class="categories__line"
                                            v-for="category in sortedCategories"
                                            :key="category.id"
                                        >
                                            <div class="categories__move">
                                                <button type="button" class="move">Move Item</button>
                                            </div>
                                            <div class="categories__photo">
                                                <a href="javascript:void(0)" class="photo">
                                                    <img :src="getNameOfAvatar(category.image)" alt="Category Photo" width="230">
                                                </a>
                                            </div>
                                            <div class="categories__name">
                                                <a href="javascript:void(0)" class="name"> {{ category.name }}</a>
                                            </div>
                                            <div class="categories__listing">
                                                <div
                                                    class="categories__holder"
                                                    :class="{ categories__holder_full: isCollapsed[category.id] }"
                                                >
                                                    <ul class="list">
                                                        <li
                                                            v-for="subcategory in category.subcategories"
                                                            :key="subcategory.id"
                                                        >
                                                            {{subcategory.name}}
                                                        </li>

                                                    </ul>
                                                    <button
                                                        v-if="category.subcategories.length > 0"
                                                        class="categories__more"
                                                        @click.prevent="toggleList(category.id)"
                                                    ></button>
                                                </div>
                                            </div>
                                            <div class="categories__edit">
                                                <a :href="`/admin/category/${category.id}/edit`" class="edit">
                                                    <svg width="16" height="16" class="icon">
                                                        <use href="/img/svg/symbol-defs.svg#icon-edit"></use>
                                                    </svg>
                                                </a>
                                            </div>
                                            <div class="categories__status" v-if="category.isActive">
                                                <button
                                                    type="button"
                                                    class="status status_make-inactive"
                                                    @click="changeStatus(category.id)"
                                                >
                                                    Make Inactive
                                                </button>
                                            </div>
                                            <div class="categories__status" v-else>
                                                <button
                                                    type="button"
                                                    class="status status_make-active"
                                                    @click="changeStatus(category.id)"
                                                >
                                                    Make Active
                                                </button>
                                            </div>
                                        </li>
                                    </draggable>
                                </ul>
                            </div>
                        </div>
                    </form>
                </div>

                <div class="tab-pane fade" id="second" v-else>
                    <div class="categories__empty">
                        <svg width="45" height="45" area-hidden="true">
                            <use href="/img/svg/symbol-defs.svg#icon-cinema"></use>
                        </svg>
                        <p>There are no categories</p>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import {defineComponent} from 'vue'
import {mapActions, mapState} from "pinia";
import {useAdminStore} from "../../stores/AdminStore";
import AdminService from "../../services/AdminService";
import draggable from "vuedraggable";

export default defineComponent({
    name: "ListOfCategories",
    components: {draggable},
    data() {
        return {
            sortStatus: 'active',
            isCollapsed: {}
        }
    },
    computed: {
     ...mapState(useAdminStore, {
         listOfCategories: 'categories'
     }),
        sortedCategories: {
            get() {
                return this.sortStatus === 'active'
                    ? this.listOfCategories.active
                    : this.listOfCategories.inactive;
            },
            set(newValue) {
                if (this.sortStatus === 'active') {
                    this.listOfCategories.active = newValue;
                } else {
                    this.listOfCategories.inactive = newValue;
                }
            }
        }
    },
    methods: {
        onDragEnd() {
            const newOrderCategories = this.sortedCategories.map((item) => item.id);
            this.sendPositionToBackend(newOrderCategories);
        },

        async sendPositionToBackend(newOrderCategories) {
            this.$showLoadingMessage()
            try {
                await AdminService.updateCategoriesOrder(newOrderCategories)
                this.$showSuccessMessage('The order was updated')
            } catch (e) {
                this.$showErrorMessage('The order was not updated')
            }
        },

        toggleList(categoryId) {
            this.$set(this.isCollapsed, categoryId, !this.isCollapsed[categoryId]);
        },
        ...mapActions(useAdminStore, {
            fetchListOfCategories: 'fetchListOfCategories'
        }),
        getNameOfAvatar(photo) {
            return photo ? `/uploads${photo.file_path}` : "/img/svg/avatar.svg";
        },
        async changeStatus(id) {
            try {
              await AdminService.updateCategoryStatus(id)
                await this.fetchListOfCategories()
            } catch {
                console.error()
            }
        }
    },
    mounted() {
        this.fetchListOfCategories()
    }
})
</script>



<style>
</style>
